import { createContext } from 'react';
import { LANGUAGES, type Language, type Translation } from './translations';

export type LanguageContextValue = {
  language: Language;
  languages: typeof LANGUAGES;
  setLanguage: (language: Language) => void;
  t: Translation;
};

export const LanguageContext = createContext<LanguageContextValue | null>(null);
